module.exports = __webpack_public_path__ + "img/job-search-bkrnd.44f1ae19.jpg";